import { getEuropeanUnionContries } from 'utilities/getEuropeanUnionContries';
import { isCountrySpain } from 'utilities/multiLanguageHelper';
import { useEffect, useMemo } from 'react';
import { getIsSelectedCountryDifferent } from 'components/newAccountSteps/initialStep/sections/PersonalData/utils/getIsSelectedCountryDifferent';

export const usePassport = ({ countries, nationality, documentType, formActions }) => {
    const isPassportRequired = useMemo(() => {
        const ueCountries = getEuropeanUnionContries(countries, documentType);
        const isUECountry = ueCountries.indexOf(nationality) !== -1;

        return isCountrySpain() && nationality && getIsSelectedCountryDifferent(nationality) && isUECountry;
    }, [nationality]);

    useEffect(() => {
        if (!isPassportRequired) {
            formActions.reset('userProfile.passport');
        }
    }, [isPassportRequired]);

    return isPassportRequired;
};
